import { io, type Socket } from 'socket.io-client';
import type { ClientToServerEvents, ServerToClientEvents } from '../shared/socket.js';

export type { ClientToServerEvents, ServerToClientEvents } from '../shared/socket.js';

let socket: Socket<ServerToClientEvents, ClientToServerEvents> | undefined;

export function getSocket() {
  if (!socket) {
    socket = io({
      transports: ['polling', 'websocket'],
      autoConnect: true
    });
  }
  return socket;
}